module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lv-month-picker"
  }, [_c('span', {
    staticClass: "lv-month-icon"
  }, [_c('svg', {
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "4",
      "width": "18",
      "height": "18",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 2v4M8 2v4M3 10h18"
    }
  })])]), _vm._v(" "), _c('vue-monthly-picker', {
    staticClass: "lv-month-control",
    attrs: {
      "value": _vm.value,
      "selectedBackgroundColor": _vm.selectedBackgroundColor,
      "monthLabels": _vm.monthLabels,
      "dateFormat": _vm.dateFormat,
      "clearOption": _vm.clearOption,
      "placeHolder": _vm.placeholder
    },
    on: {
      "input": _vm.onInput,
      "selected": _vm.onSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa34a7c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/LvMonthPicker.vue
// module id = 1750
// module chunks = 2